import type { ReactNode } from 'react';

import {
  checkboxDescription,
  checkboxError,
  checkboxGroupRoot,
  checkboxLabel,
  checkboxRoot,
} from '@mage-ui/styled-system/recipes';
import {
  Checkbox as MantineCheckbox,
  Group as MantineGroup,
} from '@mantine/core';

export type CheckboxGroupProps = {
  label?: ReactNode;
  error?: ReactNode;
  description?: ReactNode;
  children?: ReactNode;
  value?: string[];
  name?: string;
  onChange?: (value: string[]) => void;
  classNames?: {
    root?: string;
    radio?: string;
    icon?: string;
    inner?: string;
    body?: string;
    labelWrapper?: string;
    label?: string;
    description?: string;
    error?: string;
    groupRoot?: string;
  };
};

export const CheckboxGroup = ({
  classNames,
  children,
  ...props
}: CheckboxGroupProps): ReactNode => {
  return (
    <MantineCheckbox.Group
      classNames={{
        root: classNames?.root ?? checkboxRoot(),
        label: classNames?.label ?? checkboxLabel(),
        description: classNames?.description ?? checkboxDescription(),
        error: classNames?.error ?? checkboxError(),
      }}
      {...props}
    >
      <MantineGroup
        classNames={{
          root: classNames?.groupRoot ?? checkboxGroupRoot(),
        }}
      >
        {children}
      </MantineGroup>
    </MantineCheckbox.Group>
  );
};

CheckboxGroup.displayName = 'Checkbox.Group';
